import { IListViewTableColumns, Order } from '~/src/dash/components/tables/ListViewTable/common';

export interface ISSAIHouseAdsCfg {
  config: {
    activeColumnKeys: string[];
    isExpanded: boolean;
    isReadAuthorized: boolean;
    isWriteAuthorized: boolean;
    displayNameWithID: boolean;
    enableActions: boolean;
    order: Order;
    orderBy: string;
    rowsPerPage: number;
  };
  table: {
    columns: IListViewTableColumns;
  };
}

export const ssaiHouseAdsCfg: ISSAIHouseAdsCfg = {
  config: {
    activeColumnKeys: ['Hash', 'TranscodeStatus'],
    isExpanded: false,
    isReadAuthorized: true,
    isWriteAuthorized: true,
    displayNameWithID: true,
    enableActions: true,
    order: 'desc',
    orderBy: 'Name',
    rowsPerPage: 10,
  },
  table: {
    columns: {
      ID: {
        isHidden: true,
        key: 'ID',
        label: 'ID',
        responseKey: '',
        valueType: 'string',
        headerRenderType: 'string',
      },
      Name: {
        key: 'Name',
        label: 'Name',
        responseKey: '',
        valueType: 'string',
        cellRenderType: 'string',
        headerRenderType: 'string',
      },
      Hash: {
        key: 'Hash',
        label: 'Hash',
        responseKey: '',
        valueType: 'component',
        headerRenderType: 'string',
      },
      Actions: {
        key: 'Actions',
        label: 'Actions',
        responseKey: '',
        valueType: 'component',
        headerRenderType: 'actions',
        cellRenderType: 'actions',
      },
      TranscodeStatus: {
        key: 'TranscodeStatus',
        label: 'Transcode Status',
        responseKey: '',
        valueType: 'component',
        headerRenderType: 'centered_text',
      },
      Status: {
        isHidden: true,
        key: 'Status',
        label: 'Status',
        responseKey: '',
        valueType: 'string',
        headerRenderType: 'string',
      },
    },
  },
};
